import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Basket = function Basket(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.993 13.5a1 1 0 102 0 1 1 0 00-2 0zm5 0a1 1 0 102 0 1 1 0 00-2 0zm2-2.987c-.282.682-1.101.987-1.727.987H7.447c-.612 0-1.123-.556-1.345-1.149C5.88 9.76 3.992 3.5 3.992 3.5h-1.5C1.74 3.5 1 3.251 1 2.492S1.74 1.5 2.493 1.5h1.5c.667 0 1 .176 1.475.992 0 0 .225.837.525 2.008h7.5c.42 0 .963-.006 1.21.28.249.284.372.544.249 1.178 0 0-1.677 3.873-1.96 4.555z",
    fill: "currentColor"
  }));
};
export default Basket;